import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { queryClient } from './api/queryClient';
import { router } from './router';
import { reloadOnStaleChunks } from './lib/chunks';
import { ToastProvider } from './ui';
import './styles/tokens.css';
import './styles/base.css';
import './ui/ui.css';
import './styles/app.css';

reloadOnStaleChunks();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
